import '@aplicy-com/chat-ui/style.css';
import {
  ChatProvider,
  Chat as ChatUi,
  initChatConfig,
} from '@aplicy-com/chat-ui';
import { useAuth } from '../../../../context/AuthContext';
import { useEffect } from 'react';
import { apiClient } from '../../../../api';

const Chat = () => {
  initChatConfig({
    apiUrl: `/chat`,
    // apiUrl: `http://localhost:3030`,
    role: 'customer',
    cdnUrl: `${import.meta.env.VITE_APP_CDN_URL}/`,
    webSocketUrl: `${import.meta.env.VITE_APP_WEBSOCKET}`,
    apiClient: apiClient,
  });

  const { userId, activeBusinessId } = useAuth();

  // Direct inline-style override for problematic img selectors as a fallback
  useEffect(() => {
    const applyStyles = () => {
      const directImgs = document.querySelectorAll(
        '.hp-chat-app img.w-10.h-10, .hp-chat-app img.w-10, .hp-chat-app img.chatMessageContainerInnerImg'
      );
      directImgs.forEach((el) => {
        const img = el as HTMLElement;
        img.style.setProperty('width', '2.5rem', 'important');
        img.style.setProperty('height', '2.5rem', 'important');
        img.style.setProperty('min-width', '2.5rem', 'important');
        img.style.setProperty('min-height', '2.5rem', 'important');
        img.style.setProperty('max-width', 'none', 'important');
        img.style.setProperty('max-height', 'none', 'important');
        img.style.setProperty('object-fit', 'cover', 'important');
        img.style.setProperty('display', 'block', 'important');
        img.style.setProperty('vertical-align', 'middle', 'important');
        img.style.setProperty('border-radius', '9999px', 'important');
      });
    };

    applyStyles();

    // Observe DOM changes in case chat UI renders images later
    const root = document.querySelector('.hp-chat-app');
    if (!root) return;

    const observer = new MutationObserver(() => {
      applyStyles();
    });
    observer.observe(root, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, []);

  return (
    <div className="hp-chat-app min-w-0 h-full max-h-[calc(100vh-4rem)]">
      <ChatProvider
        userId={userId || ''}
        businessId={activeBusinessId ?? undefined}
      >
        <ChatUi
          onMarkCompleted={() => {
            // Navigate to the bookings page (no deep-link — the awaiting booking
            // shows in the normal list; avoids the duplicate highlighted card).
            window.location.href = '/customer/customer-booking';
          }}
        />
      </ChatProvider>
    </div>
  );
};

export default Chat;
